import useReactQuery from '../common/useReactQuery';

const useAcceptInvitation = () => {
  const { useMutation } = useReactQuery();

  return useMutation<void>({
    method: 'POST',
    url: '/api/school_communication/parents/invitations/accepts',
  });
};

export default useAcceptInvitation;
